const riot = require('riot');

riot.tag2('module-provider-ponta', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">特典を受け取る</div> </div> <div class="px24 mtn105"> <div class="w-full p20 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb16"><img class="block s85 object-fit-contain" src="/images/ponta/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">Pontaポイント コード</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString()}</div> <div class="ts-hs text-gray_60">ポイント</div> </div> </div> <div class="mb80" if="{mode === &quot;input_mail&quot;}"> <div class="ts-ps text-gray_80 mb24">特典としてPontaポイント コードを受け取ることができます。受け取るメールアドレスをご入力ください。</div> <form onsubmit="{toConfirm}"> <input class="input w-full mb24" ref="email" placeholder="メールアドレス" required riot-value="{email}" type="{\'email\'}"> <label class="f fm fit-content cursor-pointer mb26"> <input class="checkbox mr10" type="checkbox" onchange="{onToggleAgree}"> <p class="ts-ps"> <a class="text-link" href="/campaigns/{opts.event.campaign_id}/terms">個人情報の取り扱い</a>に同意しました</p> </label> <button class="button size-l primary w-full mb26" disabled="{!agreeTerms}">確認</button> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{inputMessage}"></p> </form> </div> <div class="mb40" if="{mode === &quot;confirm_mail&quot;}"> <div class="ts-hs text-gray_80 mb24">メールアドレスのご確認</div> <div class="ts-ps text-gray_80 mb24">こちらのメールアドレスに noreply@incentive.repro.io から<br>Pontaポイント コードをお送りします。</div> <form onsubmit="{sendMail}"> <input class="input w-full mb24" readonly riot-value="{email}" type="{\'email\'}"> <button class="button size-l primary w-full mb30">メールアドレスを確定</button> </form> <div class="f fh mb30"> <button class="button size-xs text" type="button" onclick="{toInput}">メールアドレスを修正する</button> </div> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{confirmMessage}"></p> </div> </div>', 'module-provider-ponta,[data-is="module-provider-ponta"]{display:block}', 'class="w-full"', function(opts) {
    this.inputMessage = '「Ponta」は、株式会社ロイヤリティマーケティングの登録商標です。\n「Pontaポイント コード」は、株式会社ロイヤリティマーケティングとの発行許諾契約により、株式会社NTTカードソリューションが発行するサービスです。'
    var confirm_message = `■Pontaポイント コードとは
    Pontaポイント コードは、Ponta会員IDにPontaポイントを加算できるサービスです。
    Pontaポイント コードの詳細はこちら（ https://atgift.jp/user/item/pontapointcode/ ）をご覧ください。

    ■Pontaポイント コードの注意事項
    ・Pontaポイントの加算登録には、PontaWeb会員登録が必要です。
    ・PontaWeb会員登録の際には、Ponta会員IDとリクルートIDのご登録が必要です。
    ・Pontaポイント コードには有効期限があります。有効期限を過ぎるとご利用できなくなります。
    ・Pontaポイント コードの登録キャンセル・換金・返金・再発行等はできません。
    ・Pontaポイント コードの紛失、盗難、破損、IDの漏洩等の責任は負いません。
    ・Pontaポイント コードの登録サイトは、日本国外からのアクセスはできません。
    ・その他注意事項は「利用規約」（ https://atgift.jp/user/item/pontapointcode/use-rule/ ）をご確認ください。

    「Ponta」は、株式会社ロイヤリティマーケティングの登録商標です。
    「Pontaポイント コード」は、株式会社ロイヤリティマーケティングとの発行許諾契約により、株式会社NTTカードソリューションが発行するサービスです。
    `;

    this.confirmMessage = confirm_message.replace(/^ +/gm, "");

    this.mode = 'input_mail'

    this.preload = async ({req}) => {
      var email = req.query.email;

      return {
        email,
      };
    };

    this.toConfirm = (e) => {
      e.preventDefault();
      this.email = this.refs.email.value;
      this.mode = 'confirm_mail';
      this.update();
    };

    this.toInput = () => {
      this.email = '';
      this.mode = 'input_mail';
      this.update();
    };

    this.sendMail = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      try {
        await app.api.child('ntt_card_solutions/publish').post({ onetime_hash: this.opts.onetimeHash, email: this.email });
        spat.router.push(`/receive?hash=${this.opts.onetimeHash}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.open('modal-error', {statusCode: e.status});
      }
      finally {
        indicator.close();
      }
    };

    this.onToggleAgree = (e) => {
      this.agreeTerms = e.currentTarget.checked;
    };
});